import { HEADLESS_CMS_IMAGE_URL, SELECTED_ENV } from "@globalConfig";
export var CMSImageHelper = function CMSImageHelper(url) {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return (HEADLESS_CMS_IMAGE_URL + url).replace('{env}', SELECTED_ENV === 'local' ? 'dev' : SELECTED_ENV);
};